export const lcStorageIsRememberMe = 'lcStorageIsRememberMe'
export const lcStorageUserName = 'lcStorageUserName'
export const lcStorageUserRole = 'lcStorageUserRole'
export const PREVIEW_HELP_PAGE = 'PREVIEW_HELP_PAGE'
export const TEMP_SESSION_TRANSFER = 'TEMP_SESSION_TRANSFER'